import { ENTRIES, SONG, type InstrumentId } from "./score";
import { beatTime, type ScheduledNote } from "./scheduler";
export const TAU = Math.PI * 2;
export const PERIOD = (SONG.beatsPerBar * 60) / SONG.bpm;
export const smooth = (x: number) => {
  const t = Math.max(0, Math.min(1, x));
  return t * t * (3 - 2 * t);
};
export const ORBITS: readonly {
  id: InstrumentId;
  radius: number;
  color: string;
  release: number;
}[] = [
  { id: "marimba", radius: 385, color: "#FFB35C", release: 0.42 },
  { id: "bell", radius: 295, color: "#74EEFF", release: 0.85 },
  { id: "bass", radius: 205, color: "#B29AFF", release: 0.55 },
  { id: "percussion", radius: 115, color: "#FF7398", release: 0.17 },
];
// A marker has one lifetime shorter than a revolution. It cannot re-trigger.
export const markerAngle = (event: ScheduledNote, time: number) =>
  event.triggerAngle + (TAU * (time - event.time)) / PERIOD;
export const markerVisible = (event: ScheduledNote, time: number) =>
  time >= event.time - PERIOD + 0.12 && time < event.time + 0.12;
export const position = (
  event: ScheduledNote,
  time: number,
  radius: number,
) => ({
  x: Math.cos(markerAngle(event, time)) * radius,
  y: Math.sin(markerAngle(event, time)) * radius,
});
export const entryWeight = (id: InstrumentId, time: number) =>
  id === "marimba" ? 1 : smooth((time - (beatTime(ENTRIES[id]) - 0.55)) / 0.55);
export const reaction = (
  event: ScheduledNote,
  time: number,
  release: number,
) =>
  time < event.time
    ? 0
    : Math.exp(-(time - event.time) / release) *
      (1 - smooth((time - event.end) / release));
